
import { NSpin } from 'naive-ui';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import chartStationEvents from '~/components/chart-station-events/chart-station-events.vue';

import ComponentBase from '~/components/component-base';
import StationEventsTimeline from '~/components/station-events-timeline/station-events-timeline.vue';

import { useStationDetailStore } from '~/store/station-details.store';

export default defineComponent({

    extends: ComponentBase,

    components: {
        chartStationEvents,
        StationEventsTimeline,
        NSpin,
    },

    computed: {
         ...mapState(useStationDetailStore, ['station', 'events', 'since', 'before']),
    }
});